export function update<TSource>(
  array: TSource[],
  index: number,
  value: TSource,
) {
  if (index > array.length || index < 0) {
    return array;
  }

  const result = [...array];
  result[index] = value;

  return result;
}
